import { render, staticRenderFns } from "./outwork.vue?vue&type=template&id=16f3c88c&scoped=true&"
import script from "./outwork.vue?vue&type=script&lang=js&"
export * from "./outwork.vue?vue&type=script&lang=js&"
import style0 from "./outwork.vue?vue&type=style&index=0&id=16f3c88c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f3c88c",
  null
  
)

export default component.exports